<div class="content-container mx-auto my-4">
    <h1 class="mt-0">Permit status</h1>

    @if (loading) {
        <ngxh6-loading-or-error></ngxh6-loading-or-error>
    } @else if (notFound) {
        <div class="alert alert-danger" role="alert">Permit not found.</div>
    } @else if (locked) {
        <!-- Email-confirm gate: personal details stay hidden until the applicant confirms their email. -->
        <div class="mb-3">
            <div class="h5 mb-1">{{ permitType }}</div>
            @if (status) {
                <div class="text-muted"><app-permit-status-badge [status]="status"></app-permit-status-badge></div>
            }
        </div>

        <div class="card mb-3">
            <div class="card-body">
                <h2 class="h6 mt-0">Confirm it's you</h2>
                <p class="text-muted">For your privacy, please enter the email address you used on your application to view your permit.</p>

                <form (ngSubmit)="verify()">
                    <div class="mb-3">
                        <label class="form-label" for="verify-email">Email address</label>
                        <input id="verify-email" name="email" type="email" class="form-control" [(ngModel)]="email" autocomplete="email" required />
                    </div>

                    @if (verifyError) {
                        <div class="alert alert-danger" role="alert">{{ verifyError }}</div>
                    }

                    <button type="submit" class="btn btn-primary ms-0" [disabled]="!email || verifying">
                        {{ verifying ? 'Checking…' : 'View my permit' }}
                    </button>
                </form>
            </div>
        </div>
    } @else if (permit) {
        <div class="mb-3">
            <div class="h5 mb-1">{{ permit.permitType }}</div>
            <div class="text-muted">
                <app-permit-status-badge [status]="permit.status" [upcoming]="!!permit.upcoming"></app-permit-status-badge>
            </div>
        </div>

        <!-- TLC are firm that the PDF is the only permit document. This page is a status
         view, so it says so loudly on an issued permit and makes the PDF the one clear
         action - the summary below is just that, a summary. -->
        @if (permit.status === 'active') {
            <div class="alert alert-warning" role="alert">
                <div class="d-flex align-items-start gap-3">
                    <i class="fa fa-triangle-exclamation fa-lg mt-1" aria-hidden="true"></i>
                    <div>
                        <h2 class="h5 mt-0 mb-1">This page is not your permit</h2>
                        <p class="mb-0">
                            Your permit is the <strong>PDF document</strong>. Download it and carry it &mdash; on your phone or printed &mdash; whenever you are
                            on Tiwi land. Everything below is only a summary of your permit's status.
                        </p>
                    </div>
                </div>
                <a class="btn btn-primary btn-lg ms-0 mt-3" [href]="pdfUrl" target="_blank" rel="noopener">
                    <i class="fa fa-file-pdf me-2" aria-hidden="true"></i>Download your permit (PDF)
                </a>
            </div>
        }

        @if (permit.status === 'needs_info') {
            <div class="alert alert-warning" role="alert">
                <h4 class="mt-0 h6">More information needed</h4>
                @if (permit.needsInfoNote) {
                    <p class="mb-2">{{ permit.needsInfoNote }}</p>
                }
                <p class="mb-0">We've emailed you a secure link to update your application and send it back for review.</p>
            </div>
        } @else if (permit.status === 'pending_payment') {
            <!-- Approved but not yet issued - the pay panel below carries the call to action,
         so this only needs to be clear that it isn't a permit yet. -->
            <div class="alert alert-info" role="alert">
                Your application is <strong>provisionally approved</strong>. It becomes a valid permit once payment is received - you are not approved to be
                on-island until then.
            </div>
        } @else if (permit.status !== 'active') {
            <div class="alert alert-info" role="alert">
                Your application is <strong>{{ permit.statusLabel || permit.status }}</strong
                >. You are not approved to be on-island until your permit is approved.
            </div>
        }

        @if (awaitingIssue) {
            <div class="alert alert-info" role="alert">
                <strong>Payment received.</strong> We're issuing your permit now - this page will update in a moment.
            </div>
        } @else if (permit.status === 'pending_payment') {
            <app-permit-pay [token]="token!" (paid)="onPaid()"></app-permit-pay>
        }

        <div class="card mb-3">
            <div class="card-body">
                <app-permit-detail [permit]="permit"></app-permit-detail>
            </div>
        </div>

        @if (permit.history?.length) {
            <div class="card mb-3">
                <div class="card-body">
                    <h2 class="h6 mt-0 mb-3">Status history</h2>
                    <app-permit-history [history]="permit.history"></app-permit-history>
                </div>
            </div>
        }

        @if (canListAll) {
            <p class="mt-3 mb-0"><a routerLink="/my-permits">See all of my permits</a></p>
        }

        @if (remembered) {
            <!-- The counterpart to remembering: an obvious way to re-lock a shared computer. -->
            <p class="text-muted small mt-3 mb-0">
                This device remembers you for a short time so you don't have to re-enter your email.
                <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="forgetDevice()">Forget me on this device</button>
            </p>
        }
    }
</div>
